import { PredefinedPricingTierDto } from './predefined-pricing-tier.dto';

export class PredefinedPricingTier {
    readonly id: string;
    readonly label: string;
    readonly minUsers: number;
    readonly maxUsers: number | null;
    /** Price in cents per currency code (ISO 4217). */
    readonly prices: Record<string, number>;

    constructor(dto: PredefinedPricingTierDto) {
        this.id = dto.id;
        this.label = dto.label;
        this.minUsers = dto.minUsers;
        this.maxUsers = dto.maxUsers;
        this.prices = dto.prices ?? {};
    }
}
